import React, { useState, useEffect } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import styles from "./index.module.scss";

import AccordionMUI from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default function Accordion({ summary, details, ...props }) {
  const useStyles = makeStyles(theme => ({
    accordion: {
      width: "100%",
      borderTop: `1px solid ${theme.palette.grey[500]}`,
      borderBottom: `1px solid ${theme.palette.grey[500]}`,
      boxShadow: "none",
      marginTop: "-1px",
      "&.Mui-expanded:first-child": {
        marginTop: "-1px",
      },
    },
    accordionSummary: {
      padding: 0,
    },
    accordionSummaryContent: {
      color: props.titleColor ? props.titleColor : theme.palette.secondary.main,
      fontSize: "1rem",
      margin: "18px 0",
    },
    accordionDetails: {
      padding: "16px 0",
    },
  }));

  const [tabHead, setTabHead] = useState(summary);
  const [tabContent, setTabContent] = useState(details);

  const classes = useStyles();

  useEffect(() => {
    setTabContent(details);
  }, [details]);
  useEffect(() => {
    setTabHead(summary);
  }, [summary]);
  // enhancement -- to collapsed other accordions in grouping
  // const [expanded, setExpanded] = React.useState(false);

  // const handleChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  return (
    <div className={styles.container}>
      <AccordionMUI className={classes.accordion} square={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-content"
          id="panel-header"
          classes={{
            root: classes.accordionSummary,
            content: classes.accordionSummaryContent,
          }}
        >
          {tabHead}
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          {tabContent}
        </AccordionDetails>
      </AccordionMUI>
    </div>
  );
}
